























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Meter from "@/data/models/meter";
import MeterIdentificationResponses from "@/data/models/meterModelResponse";
import dayjs from "dayjs";
import Button from "@/components/commons/Button.vue";
import CreateMeterIdentifications from "@/components/meters/detail/CreateMeterIdentifications.vue";
import MeterModelForm from "@/data/models/meter-model-form";

@Component({
  components: {CreateMeterIdentifications, Button},
  filters: {
    toDate(date: any) {
      return dayjs(date).format("DD/MM/YYYY")
    }
  }
})
export default class IdentificationsMultiple extends Vue {
  @Prop({required: true})
  opened: boolean;

  @Prop({required: true})
  buildingId: string;

  data: { meter: Meter, models: MeterIdentificationResponses[] }[] = [];

  createIdentificationModal = false;
  meterModelForm: MeterModelForm = MeterModelForm.map({});

  deleting = {};

  mounted(): void {
  }

  @Watch('opened', {immediate: true})
  onOpen(): void {
    if (this.opened) {
      this.refreshList();
    }
  }

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
  }

  requestDeleting(meterId: string, itemToDelete: string): void {
    this.$set(this.deleting, itemToDelete, true);
    this.$dao
        .buildings.removeIdentifications(this.buildingId, meterId, itemToDelete)
        .then(() => this.refreshList())
        .finally(() => this.$delete(this.deleting, itemToDelete));
  }

  refreshList(): void {
    this.$store.commit("showLoader", true);
    this.$dao.buildings
        .getIdentifications(this.buildingId)
        .then((result) => this.data = result)
        .finally(() => this.$store.commit("showLoader", false))
  }

  requestCompute(): void {
    this.meterModelForm.buildingId = this.buildingId;
    this.createIdentificationModal = true;
  }
}
